module.exports = __webpack_public_path__ + "static/life-insurance-hero.e2d2b408.webp";